import QRCode from 'qrcode';

/**
 * Render QR after Alpine x-show reveals the canvas (double rAF).
 */
export async function renderQrCanvas(canvas, data, { width = 200, margin = 1 } = {}) {
  if (!canvas || data == null || data === '') {
    return false;
  }

  await new Promise((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(resolve));
  });

  try {
    await QRCode.toCanvas(canvas, String(data), {
      width,
      margin,
      errorCorrectionLevel: 'M',
      color: { dark: '#0B1220', light: '#FFFFFF' },
    });
    return true;
  } catch (err) {
    console.warn('QR render failed', err);
    return false;
  }
}

export async function renderQrById(canvasId, data, options = {}) {
  const canvas = document.getElementById(canvasId);
  return renderQrCanvas(canvas, data, options);
}

/**
 * Buat data URL PNG untuk isi QR (kode / payload).
 */
export async function qrToDataUrl(data, { width = 512, margin = 2 } = {}) {
  if (data == null || data === '') {
    throw new Error('Data QR kosong.');
  }

  return QRCode.toDataURL(String(data), {
    width,
    margin,
    errorCorrectionLevel: 'H',
    color: { dark: '#0B1220', light: '#FFFFFF' },
  });
}

/**
 * Unduh PNG QR — untuk ditempel di video YouTube / media.
 */
export async function downloadQrPng(data, filename = 'uspatih-qr.png', options = {}) {
  const dataUrl = await qrToDataUrl(data, options);
  const safeName = String(filename || 'uspatih-qr.png')
    .replace(/[^\w.\-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '') || 'uspatih-qr.png';
  const name = safeName.toLowerCase().endsWith('.png') ? safeName : `${safeName}.png`;

  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = name;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();

  return dataUrl;
}

if (typeof window !== 'undefined') {
  window.renderQrCanvas = renderQrCanvas;
  window.renderQrById = renderQrById;
  window.qrToDataUrl = qrToDataUrl;
  window.downloadQrPng = downloadQrPng;
}
